export function adminPath(page) {
  const base = process.env.BASE_URL || '/';
  return `${base === '/admin/' ? '/' : '/admin/'}${page}`;
}
